import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetCarRatesQueryVariables = Types.Exact<{
  input: Types.GetCarRatesInput;
}>;

export type GetCarRatesQuery = {
  __typename?: 'Query';
  getCarRates: {
    __typename?: 'GetCarRatesResult';
    vehicles: Array<{
      __typename?: 'CarRateVehicleDto';
      provider: Types.CarRateProvider;
      carRentalId: string;
      status: string;
      description: string;
      acrissCode?: string | null;
      mileageTracking?: string | null;
      fuelLevel?: string | null;
      offerToken?: string | null;
      paymentCollection?: Types.CarPaymentCollection | null;
      paymentRegistrationRequired?: boolean | null;
      dueAtBooking?: {
        __typename?: 'TravelMonetaryValue';
        currency: Types.TravelCurrencyCode;
        floatingPointDecimalString: string;
        digits: number;
        valueInMinorUnitsBigInt: any;
        valueInMinorUnits: number;
      } | null;
      vendor: { __typename?: 'CarRateVendorDto'; id: string; name: string; imageUrl?: string | null };
      vehicle: {
        __typename?: 'CarRateVehicleSpecDto';
        category: Types.VehicleCategory;
        size: Types.VehicleSize;
        transmissionType: string;
        driveType: string;
        fuelType: string;
        airConditioned: boolean;
        passengers?: number | null;
        doorCount?: number | null;
        baggageQuantity?: number | null;
        doors?: { __typename?: 'CarRateDoorRangeDto'; min?: number | null; max?: number | null } | null;
        luggage?: { __typename?: 'CarRateLuggageDto'; small?: number | null; large?: number | null } | null;
      };
      includedInsurance: Array<{
        __typename?: 'CarRateInsuranceCoverageDto';
        type: string;
        description?: string | null;
        deductible?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        tripRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
      }>;
      image?: { __typename?: 'CarRateImageDto'; caption?: string | null; url?: string | null } | null;
      photo?: { __typename?: 'Photo'; id: string } | null;
      pricing: {
        __typename?: 'CarRatePricingDto';
        dailyRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        dailyRateStrikethrough?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        totalInclusive?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        totalInclusiveStrikethrough?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        totalExclusive?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        fees?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
        refundableSecurityDeposit?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          floatingPointDecimalString: string;
          digits: number;
          valueInMinorUnitsBigInt: any;
          valueInMinorUnits: number;
        } | null;
      };
      pickUpLocation?: {
        __typename?: 'CarRateLocationDto';
        name?: string | null;
        type?: string | null;
        address?: {
          __typename?: 'CarRateAddressDto';
          line1?: string | null;
          line2?: string | null;
          city?: string | null;
          stateProvinceName?: string | null;
          postalCode?: string | null;
          countryCode?: string | null;
        } | null;
        coordinates?: { __typename?: 'CarRateCoordinatesDto'; latitude?: number | null; longitude?: number | null } | null;
        rating?: { __typename?: 'CarRateLocationRatingDto'; overall?: number | null; count?: number | null } | null;
      } | null;
      dropOffLocation?: {
        __typename?: 'CarRateLocationDto';
        name?: string | null;
        type?: string | null;
        address?: {
          __typename?: 'CarRateAddressDto';
          line1?: string | null;
          line2?: string | null;
          city?: string | null;
          stateProvinceName?: string | null;
          postalCode?: string | null;
          countryCode?: string | null;
        } | null;
        coordinates?: { __typename?: 'CarRateCoordinatesDto'; latitude?: number | null; longitude?: number | null } | null;
        rating?: { __typename?: 'CarRateLocationRatingDto'; overall?: number | null; count?: number | null } | null;
      } | null;
      cancellationPolicies: Array<{
        __typename?: 'TravelOfferCancellationPolicyRule';
        start: string;
        end?: string | null;
        estimatedFeeAmount?: { __typename?: 'TravelMonetaryValue'; valueInMinorUnitsBigInt: any } | null;
        estimatedCancellationAmount?: {
          __typename?: 'TravelOfferEstimatedCancellationAmount';
          valueType: Types.TravelOfferCancellationPolicyRuleValueType;
          amount: {
            __typename?: 'TravelMonetaryValue';
            currency: Types.TravelCurrencyCode;
            floatingPointDecimalString: string;
            digits: number;
            valueInMinorUnitsBigInt: any;
            valueInMinorUnits: number;
          };
        } | null;
      }>;
    }>;
  };
};

export type MoneyFragment = {
  __typename?: 'TravelMonetaryValue';
  currency: Types.TravelCurrencyCode;
  floatingPointDecimalString: string;
  digits: number;
  valueInMinorUnitsBigInt: any;
  valueInMinorUnits: number;
};

export type CarLocationFragment = {
  __typename?: 'CarRateLocationDto';
  name?: string | null;
  type?: string | null;
  address?: {
    __typename?: 'CarRateAddressDto';
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    stateProvinceName?: string | null;
    postalCode?: string | null;
    countryCode?: string | null;
  } | null;
  coordinates?: { __typename?: 'CarRateCoordinatesDto'; latitude?: number | null; longitude?: number | null } | null;
  rating?: { __typename?: 'CarRateLocationRatingDto'; overall?: number | null; count?: number | null } | null;
};

export const MoneyFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnitsBigInt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarLocationFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CarRateLocationDto' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateProvinceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coordinates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'overall' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetCarRatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCarRates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCarRatesInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCarRates' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'carRentalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'acrissCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mileageTracking' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelLevel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offerToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentCollection' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentRegistrationRequired' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dueAtBooking' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vendor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'transmissionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'driveType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'airConditioned' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passengers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'doorCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'baggageQuantity' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'doors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'luggage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'includedInsurance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deductible' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tripRate' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dailyRate' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dailyRateStrikethrough' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalInclusive' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalInclusiveStrikethrough' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalExclusive' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fees' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'refundableSecurityDeposit' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pickUpLocation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CarLocation' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dropOffLocation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CarLocation' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedFeeAmount' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnitsBigInt' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Money' } }] },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnitsBigInt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CarRateLocationDto' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateProvinceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coordinates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'overall' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCarRatesQuery__
 *
 * To run a query within a React component, call `useGetCarRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCarRatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCarRatesQuery, GetCarRatesQueryVariables>) {
  return ApolloReactHooks.useQuery<GetCarRatesQuery, GetCarRatesQueryVariables>(GetCarRatesDocument, baseOptions);
}
export function useGetCarRatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCarRatesQuery, GetCarRatesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetCarRatesQuery, GetCarRatesQueryVariables>(GetCarRatesDocument, baseOptions);
}
export type GetCarRatesQueryHookResult = ReturnType<typeof useGetCarRatesQuery>;
export type GetCarRatesLazyQueryHookResult = ReturnType<typeof useGetCarRatesLazyQuery>;
export type GetCarRatesQueryResult = Apollo.QueryResult<GetCarRatesQuery, GetCarRatesQueryVariables>;
